import { map } from "rxjs/operators";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";
import { ModalAddGarantComponent } from "../../../garant/modal-add-garant/modal-add-garant.component";


@Component({
  selector: 'app-bar-produit-bareme',
  templateUrl: './bar-produit-bareme.component.html',
  styleUrls: ['./bar-produit-bareme.component.scss']
})
export class BarProduitBaremeComponent implements OnInit {

defaultValues: any = {};
  listItems: Array<any> = [];
  items: Array<any> = [];
  @Input() currentProduit:any;
  @Input() currentBareme: any;
  @Output() onUpdateProduitBareme=new EventEmitter<any>()
  itemToSave: any = {};
  filiale_id: any;
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 30;
  totalItems: number;
  show_password_field = true;
  busyGet: Subscription;
  busySave: Subscription;
  currentLabel:any='TEST LABEL'
  loading: boolean = false;
  endPoint: string = "produit";
  title: string = "produit";
  createMessage = "";
  editMessage = "";
  deleteMessage = "";
  itemsParentFonctionnalites = [];
  itemsModeTarification: any = [];
  itemsModeFractionnement: any = [];
  gender = "M";
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite: any = [];
  itemsGenre: any = [];
  itemsFiliale: any = [];
  searchKey: any;
  dateNais: any;
  indiceTab: number = 0;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword = false;
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsTypeGarant: any;
  itemsTypeAssurance: any[];
  itemsModeReconduction: any;
  isTarificationFamille: any;
  bsModalRefPreview: BsModalRef;
  itemsGarant: any;
  itemsGarantProduit: any[];
  currentFamilleGarantieBaremeStatut: any;
  itemsJourAutoriseToSave: any;
  itemToAdd: any = {};
  itemsPrimeByProduit: any = [];
  itemsStatut: any;
  currentData: any;
  itemsReseauDeSoin: any = [];
  is_tarif_famille: boolean;
  itemsStatutInitialized: any = [];
  itemsGarantie: any;
  itemsGarantieProduit: any = [];
  itemsPrimeStatut: any = [];
  itemsPrimeTrancheAge: any = [];
  itemsPrimeTrancheAgeStatut: any = [];
  current_produit_id: any;
  itemsParamGlobal: any;
  itemsTypeRemboursement: any;
  itemToAddTrancheAge: any = {};
  // itemsPrimeByStatutAndTrancheAge: any = [];
  // itemsPrimeByTrancheAge: any = [];
  itemToAddStatutTrancheAge: any = {};
  itemsModeCalculPrime: any;
  currentModeCalculPrime: any;
  is_all_checked = false;
  itemsConfigStatutTrancheAge: any=[];
  configPlafond: any;
  itemsConfigPlafond: any=[];
  itemsPrimeBudget: any = [];

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    // this.itemToSave.plafond_annuel_famille = 0;
    this.itemToSave.prime_par_famille = 0;

    // this.itemToSave.mode_reconduction_id=''

    setTimeout(() => {
      console.log("here");
      // this.itemToSave.date_effet = new Date()
      // this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
      if (this.currentData) {
        console.log("currentData: ", this.currentData);

        this.itemToSave = Object.assign({}, this.currentData);
        this.current_produit_id = this.itemToSave.id;
        // this.check_if_is_famille();
        // this.getItemsGarantieProduit();
        this.getItemsModeCalculPrime()
      }
    }, 50);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes: ",changes)
    if (changes && changes.currentProduit && changes.currentProduit.currentValue) {
      if (changes && changes.currentBareme && changes.currentBareme?.currentValue) {
        // if(this.currentBareme.id){
        //   this.getItemsProduitBareme()
        // }
        // else{
        //   this.itemToSave = Object.assign({}, this.currentProduit)
        // }
        this.itemToSave = Object.assign({}, this.currentProduit)
      }
    }
    this.onChangeAnyThing()
    
  }
  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  

  

  

  
  

  

  getItemsProduitBareme() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {
        bareme_id: this.currentBareme.id,
        produit_id:this.currentProduit.id
      },
    };

    this.busyGet = this.restClient
      .post("produitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemToSave = Object.assign({}, res["items"][0])

          } else {
            this.itemToSave = {};
          }
        },
        (err) => {
          this.itemToSave = {};
        }
      );
  }
  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );

            this.itemsTypeRemboursement.sort((a, b) =>
              this.customSortTypeRembCodification(a, b)
            );
            // this.defaultValues.type_remboursement_id = this.itemsTypeRemboursement.filter(itr=>itr.codification=='TPRD')[0].id
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => {
          this.itemsTypeRemboursement = [];
        }
      );
  }

  getItemsModeReconduction() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeReconduction/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeReconduction = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeReconduction = [];
          }
        },
        (err) => {
          this.itemsModeReconduction = [];
        }
      );
  }
  getItemsModeCalculPrime() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeCalculPrime/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeCalculPrime = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
            if (!this.itemToSave.id) {
              this.itemToSave.mode_calcul_prime_id =
                this.itemsModeCalculPrime.find(
                  (imcp) => imcp.codification == "STATUT"
                ).id;
              this.currentModeCalculPrime = "STATUT";
              // this.onChangeModeCalculPrime()
            }
            this.itemsModeCalculPrime.sort((a, b) =>
              this.customSortModeCalculPrime(a, b)
            );
            this.onChangeModeCalculPrime()

          } else {
            this.itemsModeCalculPrime = [];
          }
        },
        (err) => {
          this.itemsModeCalculPrime = [];
        }
      );
  }

  getItemsModeTarification() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeTarification/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeTarification = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
            if (!this.itemToSave.id) {
            }
          } else {
            this.itemsModeTarification = [];
          }
        },
        (err) => {
          this.itemsModeTarification = [];
        }
      );
  }
  customSortModeCalculPrime(a, b) {
    const desiredOrder = ["STATUT", "TRANCHE-AGE", "TRANCHE-AGE-STATUT", "BUDGET"];
    return desiredOrder.indexOf(a.codification) - desiredOrder.indexOf(b.libelle);
  }

  getItemsModeFractionnement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("modeFractionnement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsModeFractionnement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsModeFractionnement = [];
          }
        },
        (err) => {
          this.itemsModeFractionnement = [];
        }
      );
  }


  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  capitalize(str) {
    return str.replace(/^\w/, (c) => c.toUpperCase());
  }

  customSort(a, b) {
    const desiredOrder = ["ASSURE", "CONJOINT", "ENFANT", "ASCENDANT", "AUTRE"];
    return desiredOrder.indexOf(a.libelle) - desiredOrder.indexOf(b.libelle);
  }

  customSortTypeRembCodification(a, b) {
    const desiredOrder = ["TPRD", "TP", "RD", "TPG"];
    return (
      desiredOrder.indexOf(a.codification) -
      desiredOrder.indexOf(b.codification)
    );
  }

  openModalPrestataireReseau() {
    if (!this.itemToSave.reseau_de_soin_id) return;
    let modal: any;
    modal = ModalViewreseauDeSoinDetailComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 5458545,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let reseau_id = this.itemToSave.reseau_de_soin_id;
    let reseau_de_soin_libelle = this.itemsReseauDeSoin.filter(
      (ird) => ird.id == reseau_id
    )[0].libelle;
    let data = {
      reseau_de_soin_id: reseau_id,
      reseau_de_soin_libelle: reseau_de_soin_libelle,
    };
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

  on_change_garant() {
    if (this.itemsGarant && this.itemsGarant.length) {
      let current_garant = {
        ...this.itemsGarant.filter(
          (ig) => ig.id == this.itemToSave.garant_id
        )[0],
      };
      console.log("current_garant: ", current_garant);
      if (!this.itemToSave.id) {
        this.itemToSave.taux_commission_sinistre =
          current_garant.taux_commission_sinistre;
        this.itemToSave.forfait_commission_sinistre =
          current_garant.forfait_commission_sinistre;
        this.itemToSave.taux_commission_prime =
          current_garant.taux_commission_prime;
        this.itemToSave.forfait_commission_prime =
          current_garant.forfait_commission_prime;
        this.itemToSave.type_remboursement_id =
          current_garant.type_remboursement_id;
        this.itemToSave.seuil_alerte_conso = current_garant.seuil_alerte_conso;
        this.itemToSave.seuil_suspension_tiers_payant =
          current_garant.seuil_suspension_tiers_payant;
        this.itemToSave.assure_remboursement =
          current_garant.assure_remboursement;
        this.itemToSave.mode_tarification_id =
          current_garant.mode_tarification_id;
        this.itemToSave.mode_reconduction_id =
          current_garant.mode_reconduction_id;
        this.itemToSave.mode_fractionnement_id =
          current_garant.mode_fractionnement_id;
        this.itemToSave.reseau_de_soin_id = current_garant.reseau_de_soin_id;
      }
    }
  }

  getItemsReseauDeSoin() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("reseauDeSoin/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsReseauDeSoin = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsReseauDeSoin = [];
          }
        },
        (err) => {
          this.itemsReseauDeSoin = [];
        }
      );
  }

  


  onChangeModeCalculPrime() {
    this.currentModeCalculPrime = this.itemsModeCalculPrime.find(
      (imcp) => imcp.id == this.itemToSave.mode_calcul_prime_id
    ).codification;
    console.log("currentModeCalculPrime: ", this.currentModeCalculPrime);
    this.currentLabel = this.currentModeCalculPrime
  }
  

  

  

  

  

  

  
  openModalDetailGarant() {
    if (!this.itemToSave.garant_id) {
      return;
    }
    let modal: any;
    modal = ModalViewGarantDetailsComponent;
    this.modalRef = this.modalService.show(modal, {
      id: 545854015,
      class: "modal-width-75",
      ignoreBackdropClick: true,
      // data:boulangerie
    });
    let data = { id: this.itemToSave.garant_id };
    if (data) this.modalRef.content.currentData = data;
    this.modalRef.onHide.subscribe((res) => {});
  }

 

  onChangeGarantieForm(event){
    console.log('event onChangeGarantieForm: ',event)
    this.itemsGarantieProduit = event
  }
  onChangePrimeStatutForm(event){
    console.log('event onChangePrimeStatutForm: ',event)
    // this.itemsGarantieProduit = event
    this.itemsPrimeStatut= event
  }
  onChangePrimeBudgetForm(event){
    console.log('event onChangePrimeBudgetForm: ',event)
    this.itemsPrimeBudget= event
  }
  onChangePrimeTrancheAgeForm(event){
    console.log('event onChangePrimeTrancheAgeForm: ',event)
    this.itemsPrimeTrancheAge= event.primesTrancheAge
    this.itemsConfigPlafond= event.configPlafond

  }

  onChangePrimeTrancheAgeStatutForm(event){
    console.log('event onChangePrimeTrancheAgeStatutForm: ',event)
    this.itemsPrimeTrancheAgeStatut= event.primesTrancheAgeStatut
    this.itemsConfigStatutTrancheAge= event.configPlafondTaStatut
  }
  onChangeAnyThing(){
    this.onUpdateProduitBareme.emit(this.itemToSave);
  }

  ngOnInit() {
    this.getItemsModeReconduction();
    this.getItemsModeTarification();
    this.getItemsModeFractionnement();
    this.getItemsReseauDeSoin();
    this.getItemsModeCalculPrime();
  }

}
